import { ApiError } from "./ApiError";

export default class GoneError extends ApiError {
  code = 410;
}
